// removed by extract-text-webpack-plugin
module.exports = {"container":"blocks-film-info-container","colContent":"blocks-film-info-colContent","cols":"blocks-film-info-cols","col":"blocks-film-info-col","colSocial":"blocks-film-info-colSocial","inner":"blocks-film-info-inner","actions":"blocks-film-info-actions","button":"blocks-film-info-button","colsCredits":"blocks-film-info-colsCredits","section":"blocks-film-info-section","poster":"blocks-film-info-poster","img":"blocks-film-info-img","synopsis":"blocks-film-info-synopsis","links":"blocks-film-info-links"};


//////////////////
// WEBPACK FOOTER
// ./styles/blocks/film-info.scss
// module id = 884
// module chunks = 246